
		<div class="text-center loader" style="background-image: url('/img/loader.svg'); background-repeat: no-repeat; background-position: center;" *ngIf="percent < 100">
			<div style="height: 32px; color: #D6E9FF; font-size: 11px; padding-top: 7px;">{{percent}}%</div>
		</div>
	